import { render, staticRenderFns } from "./chinaIpChart.vue?vue&type=template&id=3fd12ec2&scoped=true&"
import script from "./chinaIpChart.vue?vue&type=script&lang=js&"
export * from "./chinaIpChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd12ec2",
  null
  
)

export default component.exports